import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { OrderType } from "../../../../../../../../services/Api/Public/types";
import { OrderContext } from "../../../../contexts/OrderContext";

const OrderInfoPlace = () => {
	const { order } = useContext(OrderContext);
	const { t } = useTranslation();

	if (!order?.table || (order.type !== OrderType.DINE_IN && order.type !== OrderType.ROOM_SERVICE)) return <></>;

	const getPlaceDescription = () => {
		const room = order.table?.room_name;
		const table = order.table?.name;
		return [room, table].filter(Boolean).join(" / ");
	};

	const getPlaceTitle = () => {
		switch (order.type) {
			case OrderType.DINE_IN:
				return t("modules.e_order.field.table_nr.title");
			case OrderType.ROOM_SERVICE:
				return t("modules.e_order.field.room_nr.title");
			default:
				return "";
		}
	};

	return (
		<div className="d-flex flex-column gap-2">
			{getPlaceTitle() && getPlaceDescription() && (
				<div className="w-100 text-center">
					<small className="text-muted">{`${getPlaceTitle()}:`}</small>
					<p className="mb-0 text-muted font-weight-bold">{getPlaceDescription()}</p>
				</div>
			)}
		</div>
	);
};

export default OrderInfoPlace;
